module.exports = __webpack_public_path__ + "static/media/SARS_COV_2-GSE147507_1.43086a65.csv";